module.exports = __webpack_public_path__ + "img/equetronic-logo.bcde6f67.png";